import React from "react";
import { Skeleton } from "@mui/material";
import PropTypes from "prop-types";

const Placeholder = (props) => {
  const { variant, children, ratio, classes: originalClases, animation, className, width, height } = props;
  const getStyle = () => {
    if (!ratio) return {};
    return { height: height || "auto", aspectRatio: ratio };
  };

  return (
    <Skeleton
      classes={originalClases}
      className={className}
      style={getStyle()}
      variant={variant}
      width={width}
      height={height}
      animation={animation}
      {...props}
    >
      {children}
    </Skeleton>
  );
};

Placeholder.propTypes = {
  variant: PropTypes.string,
  ratio: PropTypes.string,
  animation: PropTypes.string,
  className: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default Placeholder;
